import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';

import httpClient from 'utils/httpClient';
import { Session } from './type';

const CREATE_SESSION = `/v2/teacher/add-unit`;

export type CreateUnit = {
  duration: number;
  occurredAt: string;
  courseId: number;
};
export type CreateUnitResponse = {
  session: Session;
};
export const createUnit = ({ duration, occurredAt, courseId }: CreateUnit) => {
  const body = { duration, occurred_at: occurredAt, 'course-id': courseId };

  return httpClient.post<CreateUnitResponse>(CREATE_SESSION, body);
};
export const useCreateUnit = (
  opts: UseMutationOptions<
    AxiosResponse<CreateUnitResponse>,
    AxiosError<any>,
    CreateUnit
  >,
) =>
  useMutation<AxiosResponse<CreateUnitResponse>, AxiosError<any>, CreateUnit>(
    createUnit,
    opts,
  );
